import { render, staticRenderFns } from "./LastProductSelected.vue?vue&type=template&id=606c9d6b"
import script from "./LastProductSelected.vue?vue&type=script&lang=js"
export * from "./LastProductSelected.vue?vue&type=script&lang=js"
import style0 from "./LastProductSelected.vue?vue&type=style&index=0&id=606c9d6b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports